import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { withElementWrapper } from "../withElementWrapper";
import { updateContentLinks, shapeStory, shapeConfig, getTextColor } from "../../../../utils/utils";
import "./text.m.css";
import { useStateValue } from "../../../SharedContext";

const TextBase = ({ element, opts = {}, css = {}, story = {}, config = {}, ...restProps }) => {
  const configData = useStateValue() || {};
  const textInvertColor = getTextColor(configData.theme);
  const content = element.text;
  if (!content) return null;
  const { textColor, hyperlinkColor = "#2f81cd" } = css;
  const { isExternalLink = true } = opts;
  const text = (isExternalLink && updateContentLinks(content)) || content;

  useEffect(() => {
    const timer = setTimeout(() => {
      var container = document.querySelector("#text-element");
      var anchorTags = container.querySelectorAll("a");
      Array.prototype.forEach.call(anchorTags, a => {
        a.style.color = hyperlinkColor;
        a.onmouseover = () => {
          a.style.borderBottom = `1px solid ${hyperlinkColor}`;
        };
        a.onmouseout = () => {
          a.style.borderBottom = "none";
        };
      });
    }, [hyperlinkColor]);
    return () => clearTimeout(timer);
  }, 300);

  return (
    <div
      className="arrow-component arr--text-element"
      styleName={`text-element ${textInvertColor}`}
      style={{ color: textColor }}
      data-test-id="text"
      dangerouslySetInnerHTML={{ __html: text }}
      id="text-element"
      {...restProps}
    />
  );
};

TextBase.propTypes = {
  element: PropTypes.shape({ text: PropTypes.string }),
  opts: PropTypes.shape({ isExternalLink: PropTypes.bool }),
  css: PropTypes.shape({ hyperlinkColor: PropTypes.string, textColor: PropTypes.string }),
  story: shapeStory,
  config: shapeConfig
};

export const Text = withElementWrapper(TextBase);
